import("@needle-tools/engine") /* async import of needle engine */
  .then(() => {
    console.log("🚀 Needle Engine 已加载完成");
  })
  .catch(error => {
    console.error("❌ Needle Engine 加载失败:", error);
  });

import "./NeedleScrollTimeline";

console.log("🚀 Needle Engine main.js 启动"); 